import { CHANGE_PASSWORD_RESPONSE, VALIDATING_JWT_TOKEN_SUCCESS, VALIDATING_JWT_TOKEN_FAILURE } from './action';

const initialState = {
   change_password : {},
   validating_jwt_token : {},
   validating_jwt_token_failure : {}
}

const changePasswordReducer = (state=initialState, action) => {
    switch(action.type) {
        case CHANGE_PASSWORD_RESPONSE:
            return  state = {
                ...state,
                change_password : action.data
            }

        case VALIDATING_JWT_TOKEN_SUCCESS:
            return  state = {
                ...state,
                validating_jwt_token : action.data
            }

        case VALIDATING_JWT_TOKEN_FAILURE:
            return  state = {
                ...state,
                validating_jwt_token_failure : action.err
            }
       
        default: return state
    }
}
export default changePasswordReducer;